'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
require('../../../typography/ErrorText/ErrorText.js');
require('../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../typography/MediumText/MediumText.js');
require('../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../typography/SmallDisabledText/SmallDisabledText.js');
var SmallEmphasizedDarkText = require('../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var styledComponents = require('./styled-components.js');

var ColoredMetric = function (props) {
    var color = props.color, name = props.name, value = props.value;
    return (React__default.createElement(styledComponents.ColorContainer, { color: color },
        React__default.createElement(core.Grid, { container: true, direction: 'column' },
            React__default.createElement(core.Grid, { item: true },
                React__default.createElement(SmallEmphasizedDarkText, null, value)),
            React__default.createElement(core.Grid, { item: true },
                React__default.createElement(SmallTitleText, null, name)))));
};

module.exports = ColoredMetric;
